var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20V16.5L14.6484 21.1484L10 25.8516V22.3516C7.44792 22.3516 5.24219 21.4401 3.38281 19.6172C1.5599 17.7578 0.648438 15.5521 0.648438 13C0.648438 11.1771 1.14062 9.51823 2.125 8.02344L3.82031 9.71875C3.27344 10.7031 3 11.7969 3 13C3 14.9323 3.67448 16.5911 5.02344 17.9766C6.40885 19.3255 8.06771 20 10 20ZM10 3.64844C12.5521 3.64844 14.7396 4.57812 16.5625 6.4375C18.4219 8.26042 19.3516 10.4479 19.3516 13C19.3516 14.8229 18.8594 16.4818 17.875 17.9766L16.1797 16.2812C16.7266 15.2969 17 14.2031 17 13C17 11.0677 16.3073 9.42708 14.9219 8.07812C13.5729 6.69271 11.9323 6 10 6V9.5L5.35156 4.85156L10 0.148438V3.64844Z",
    fill: "#181B26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.acfa6712.svg";
export { ForwardRef as ReactComponent };